import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit'
import { RootState } from '../../../app/store'
import fetchAPI from '../../../common/fetchAPI'
import { PayRuleStateClass } from './interfaces/payRuleStateClass';
const initialState: PayRuleStateClass = {
    isLoading: false,
    status: 'idle',
    payRuleList: [],
    payRuleDetailList: [],
    selectedRecord: {},
    isReload: false,
    AccountPayCodeId: 0
}
interface IThunkApi {
    state: {
        payRule: PayRuleStateClass;
    },
}
export const getAccountPayRuleDatatableAsync = createAsyncThunk
    <any, void, IThunkApi>
    (
        'payRule/getAccountPayRuleDatatable',
        async (arg, thunkApi) => {
            const response = await fetchAPI('api/V2/PayRule/GetAccountPayRuleDatatable', 'Get', '', true, 'a73f036e-6d84-440b-85e0-70e157c5eef7');
            const json = await response.json();
            return json;
        }
    )


export const getPayRuleDataByAccountPayRuleIdAsync = createAsyncThunk
    <any, any, IThunkApi>
    (
        'payRule/getPayRuleDataByAccountPayRuleId',
        async (arg, thunkApi) => {
            const response = await fetchAPI('api/V2/PayRule/' + arg, 'Get', '', true, 'a73f036e-6d84-440b-85e0-70e157c5eef7');
            const json = await response.json();
            return json;
        }
    )


export const getPayRuleDetailByAccountPayRuleIdAsync = createAsyncThunk
    <any, any, IThunkApi>
    (
        'payRule/getPayRuleDetailByAccountPayRuleId',
        async (arg, thunkApi) => {
            const AccountPayRuleId = arg;
            const response = await fetchAPI('api/V2/PayRule/GetPayRuleDetails/' + AccountPayRuleId, 'Get', '', true, 'a73f036e-6d84-440b-85e0-70e157c5eef7');
            const json = await response.json();
            return json;
        }
    )

export const addPayRuleAsync = createAsyncThunk
    <any, any, IThunkApi>
    (
        'payRule/addPayRule',
        async (arg, thunkApi) => {
            const response = await fetchAPI('api/V2/PayRule', 'POST', arg, true, 'a73f036e-6d84-440b-85e0-70e157c5eef7');
            const json = await response.json();
            return json;
        }
    )


export const addPayRuleDetailAsync = createAsyncThunk
    <any, any, IThunkApi>
    (
        'payRule/addPayRuleDetail',
        async ({ newArray, AccountPayRuleId }, thunkAPI) => {
            const response = await fetchAPI('api/V2/PayRule/PayRuleDetail/' + AccountPayRuleId, 'POST', newArray, true, 'a73f036e-6d84-440b-85e0-70e157c5eef7');
            const json = await response.json();
            return json;
        }
    )
export const updatePayRuleAsync = createAsyncThunk
    <any, any, IThunkApi>
    (
        'payRule/updatePayRule',
        async (arg, thunkApi) => {
            const { AccountPayRuleId, ...argWithoutId } = arg;
            const response = await fetchAPI('api/V2/PayRule/' + AccountPayRuleId, 'PUT', argWithoutId, true, 'a73f036e-6d84-440b-85e0-70e157c5eef7');
            const json = await response.json();
            return json;
        }
    )


export const updatePayRuleDetailsAsync = createAsyncThunk
    <any, any, IThunkApi>
    (
        'payRule/updatePayRuleDetails',
        async ({ newArray, PayRuleId }, thunkAPI) => {
            const response = await fetchAPI('api/V2/PayRule/updatePayRuleDetails/' + PayRuleId, 'PUT', newArray, true, 'a73f036e-6d84-440b-85e0-70e157c5eef7');
            const json = await response.json();
            return json;
        }
    )


export const deletePayRuleAsync = createAsyncThunk
    <any, any, IThunkApi>
    (
        'payRule/deletePayRule',
        async (arg, thunkApi) => {
            const response = await fetchAPI('api/V2/PayRule/' + arg, 'DELETE', '', true, 'a73f036e-6d84-440b-85e0-70e157c5eef7');
            const json = await response.json();
            return json;
        }
    )

export const deleteAllSelectedRecordPayRuleAsync = createAsyncThunk
    <any, any, IThunkApi>
    (
        "payRule/deleteAllSelectedRecordPayRule",
        async (arg, thunkApi) => {
            const response = await fetchAPI('api/v2/PayRule/DeleteAllSelectedRecordPayRule/', 'DELETE', arg, true, 'a73f036e-6d84-440b-85e0-70e157c5eef7');
            const json = await response.json();
            return json;
        }
    )

export const deleteAccountPayRuleDetailIdAsync = createAsyncThunk
    <any, any, IThunkApi>
    (
        "payRule/deleteAccountPayRuleDetailId",
        async (arg, thunkApi) => {
            const response = await fetchAPI('api/v2/PayRule/deleteAccountPayRuleDetailId/' + arg, 'DELETE', '', true, 'a73f036e-6d84-440b-85e0-70e157c5eef7');
            const json = await response.json();
            return json;
        }
    )



export const payRuleSlice = createSlice({
    name: 'payCode',
    initialState,
    reducers: {
        resetSelectedRecordObjectInState: (state) => {
            state.selectedRecord = {};

        },
        checkedState: (state, action) => {
            const currentindex = state.payRuleList.findIndex((item) => item.AccountPayRuleId == action.payload);
            const newArray = [...state.payRuleList];
            newArray[currentindex] = { ...newArray[currentindex], isSelected: 1 };
            state.payRuleList = newArray;
        },
        unCheckedState: (state, action) => {
            const currentindex = state.payRuleList.findIndex((item) => item.AccountPayRuleId == action.payload);
            const newArray = [...state.payRuleList];
            newArray[currentindex] = { ...newArray[currentindex], isSelected: 0 };
            state.payRuleList = newArray;
        },
        checkedAllState: (state) => {
            const newArray = state.payRuleList.map((item) => ({
                ...item,
                isSelected: 1,
            }));
            state.payRuleList = newArray;
        },
        unCheckedAllState: (state) => {
            const newArray = state.payRuleList.map((item) => ({
                ...item,
                isSelected: 0,
            }));
            state.payRuleList = newArray;
        },

    },
    extraReducers: (builder) => {
        builder
            .addCase(getAccountPayRuleDatatableAsync.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(getAccountPayRuleDatatableAsync.fulfilled, (state, { payload }) => {
                state.status = 'idle';
                state.payRuleList = payload;
                state.payRuleList.map((item: any) => {
                    item.isSelected = 0
                });
                state.isReload = false;
                state.isLoading = false;
                state.selectedRecord = {};

            })
            .addCase(getAccountPayRuleDatatableAsync.rejected, (state) => {
                state.status = 'failed';
            })

            .addCase(getPayRuleDataByAccountPayRuleIdAsync.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(getPayRuleDataByAccountPayRuleIdAsync.fulfilled, (state, { payload }) => {
                state.status = 'idle';
                state.selectedRecord = payload.Data;
            })
            .addCase(getPayRuleDataByAccountPayRuleIdAsync.rejected, (state) => {
                state.status = 'failed';
            })

            .addCase(getPayRuleDetailByAccountPayRuleIdAsync.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(getPayRuleDetailByAccountPayRuleIdAsync.fulfilled, (state, { payload }) => {
                state.status = 'idle';
                state.selectedRecord = payload.Data;
            })
            .addCase(getPayRuleDetailByAccountPayRuleIdAsync.rejected, (state) => {
                state.status = 'failed';
            })


            .addCase(addPayRuleAsync.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(addPayRuleAsync.fulfilled, (state, { payload }) => {
                state.status = 'idle';
                state.isReload = true;
            })
            .addCase(addPayRuleAsync.rejected, (state) => {
                state.status = 'failed';
            })

            .addCase(addPayRuleDetailAsync.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(addPayRuleDetailAsync.fulfilled, (state, { payload }) => {
                state.status = 'idle';
                state.isReload = true;
            })
            .addCase(addPayRuleDetailAsync.rejected, (state) => {
                state.status = 'failed';
            })

            .addCase(updatePayRuleAsync.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(updatePayRuleAsync.fulfilled, (state, { payload }) => {
                state.status = 'idle';
                state.isReload = true;
            })
            .addCase(updatePayRuleAsync.rejected, (state) => {
                state.status = 'failed';
            })

            .addCase(updatePayRuleDetailsAsync.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(updatePayRuleDetailsAsync.fulfilled, (state, { payload }) => {
                state.status = 'idle';
                state.isReload = true;
            })
            .addCase(updatePayRuleDetailsAsync.rejected, (state) => {
                state.status = 'failed';
            })

            .addCase(deletePayRuleAsync.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(deletePayRuleAsync.fulfilled, (state, { payload }) => {
                state.status = 'idle';
                state.isReload = true;
            })
            .addCase(deletePayRuleAsync.rejected, (state) => {
                state.status = 'failed';
            })
            .addCase(deleteAllSelectedRecordPayRuleAsync.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(deleteAllSelectedRecordPayRuleAsync.fulfilled, (state, { payload }) => {
                state.status = 'idle';
                state.isReload = true;
            })
            .addCase(deleteAllSelectedRecordPayRuleAsync.rejected, (state) => {
                state.status = 'failed';
            })
            .addCase(deleteAccountPayRuleDetailIdAsync.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(deleteAccountPayRuleDetailIdAsync.fulfilled, (state, { payload }) => {
                state.status = 'idle';
                state.isReload = false;
            })
            .addCase(deleteAccountPayRuleDetailIdAsync.rejected, (state) => {
                state.status = 'failed';
            })

    }
})
export const {
    resetSelectedRecordObjectInState, checkedState, unCheckedState, checkedAllState, unCheckedAllState
} = payRuleSlice.actions
export const PayRuleState = (state: RootState) => state.payRule
export default payRuleSlice.reducer